export class UserRuleModel {
    userRuleId: number;
    userRuleName: string;
      constructor(rule?) {
        rule = rule || {};
          this.userRuleId = rule.userRuleId || 0;
          this.userRuleName = rule.userRuleName || '';
        }
  }